import {doppeActionTypeDefineViewerMetadata} from "../../client-server-common/doppe-action-types/doppe-action-type";
import React from "react";
import {doppeActionTypeHoppServices} from "./doppe-action-type-hopp-services";

export const doppeActionTypeHoppServicesViewer = doppeActionTypeDefineViewerMetadata(doppeActionTypeHoppServices, {

    loadViewerComponents: async () => {
        return {
            DoppeActionTypeHoppServicesWidget: (await import(
                './doppe-action-type-hopp-services-widget/doppe-action-type-hopp-services-widget'
                )).DoppeActionTypeHoppServicesWidget
        }
    },

    renderWidget: (renderProps, viewerComponents) => {

        const {
            DoppeActionTypeHoppServicesWidget
        } = viewerComponents;

        return (
            <DoppeActionTypeHoppServicesWidget
                {...renderProps}
            />
        );
    }
}) 